<script setup lang="ts">
// @ts-nocheck
import {ref} from "vue";
import {useOfferStore} from "../../stores/offer";
import Tooltip from "../../../backend/ui/tooltip/Tooltip.vue";
import {label} from "../../mixins/translations";
import {TooltipProvider} from "reka-ui";

const offerStore = useOfferStore();
const open = ref(false)

interface Props {
    offerUrl: string,
}

defineProps<Props>()
</script>

<template>
    <TooltipProvider delay-duration="200">
        <Tooltip :content="label('site.offer.header.title')">
            <a :href="offerUrl" class="relative flex rounded-lg h-9 w-9 lg:h-12 lg:w-12 justify-center items-center border border-gray-200">
                <div
                    class="absolute flex w-7 h-7 bg-[#88c87f] text-white border-4 border-white font-bold -top-3 -right-3 rounded-full text-xs text-center leading-3 items-center justify-center">
                    <span>{{ offerStore.activeOffer?.lines_count ?? 0 }}</span>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-icon lucide-file">
                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                    <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                </svg>
            </a>
        </Tooltip>
    </TooltipProvider>
</template>
